<template>
  <div v-if="getVolunteerByService.length !== 0">
    <div class="grid lg:grid-cols-3 md:grid-cols-3 gap-4">
      <b-card
        class="mb-12 bx-shadow"
        v-for="(item, index) in getVolunteerByService"
        :key="'item -' + index"
        :item="item"
      >
        <img
          :src="
            item.profile
              ? $imageURL + '/' + item.profile
              : require('@/assets/images/blank-profile.png')
          "
          :alt="item.firstname"
          class="w-1/2 m-auto cust-profile"
          ref="cover"
        />

        <div>
          <div class="header">
            <h2
              class="text-center text-black font-semibold lg:my-4 md:my-4 my-1"
            >
              {{ item.userId.firstname }} {{ item.userId.lastname }}
            </h2>
            <!-- <p class="text-center">{{ item.location }}</p> -->
          </div>

          <!-- <div
            class="flex flex-wrap justify-center text-center lg:mt-2 md:mt-2"
          >
            <p
              class="text-black py-1 lh12px px-1 lg:mr-2 md:mr-2 lg:mb-2 md:mb-2 rounded-sm flex items-center bg-f4f5f6"
            >
              <span class="fszie10px">{{ item.expertise }}</span>
            </p>
          </div> -->

          <!-- <div class="flex flex-wrap justify-center text-center mt-2">
            <p
              class="text-black py-1 lh12px px-1 mr-2 mb-2 rounded-sm flex items-center bg-f4f5f6"
            >
              <span class="fszie13 text-black font-semibold"
                >Price: {{ item.price }}</span
              >
            </p>
          </div> -->
          <!-- <div class="w-full text-center">
            <p class="text-xs text-center lg:py-4 md:py-4 my-2">
              <span> {{ item.gender }} |</span>
              <span> {{ item.userId.mobile }} |</span>
              <span> {{ item.userId.socialMedia }} </span>
            </p>
          </div> -->
          <div class="view-btn">
            <b-button
              variant="secondary"
              class="m-auto flex bg-btn-clr px-12"
              @click.stop="handleView(item)"
              >View profile</b-button
            >
          </div>
        </div>
      </b-card>
    </div>
  </div>
  <div v-else>
    <!-- <img
      src="../../../assets/images/nodata.svg"
      alt="image"
      class="sprovider-img mx-auto"
    /> -->
    <p>No Data Available</p>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  methods: {
    async handleView(item) {
      const data = await this.$store.dispatch("respitecare/get_volunteerbyid", {
        volunteerId: item._id,
      });
      await this.$store.dispatch("respitecare/get_allreview", {
        volunteerId: item._id,
      });

      this.$router.push({
        name: "user-profile",
        query: { service: this.$route.query.service },
      });
    },
  },
  computed: {
    ...mapState("respitecare", {
      get_volunteer_by_location: "get_volunteer_by_location",
      getVolunteerByService: "getVolunteerByService",
    }),
  },
};
</script>

<style>
.cust-profile {
  margin-top: -4rem;
  border-radius: 58px;
}
.lh12px {
  line-height: 12px;
}
.rounded-sm {
  border-radius: 0.25rem;
}
.bg-f4f5f6 {
  background-color: #f4f5f6;
}
.fszie10px {
  font-size: 10px;
}
.bg-btn-clr {
  background-color: #4f0a4b;
  color: white;
}
.bg-btn-clr:hover {
  background-color: #42093f;
  color: white;
}
.bx-shadow {
  box-shadow: 0px 4px 15px 0px rgb(0 0 0 / 10%);
}
</style>
